import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import AndroidIcon from '@material-ui/icons/Android';
import AppleIcon from '@material-ui/icons/Apple';
import { JAGO_TOOLS_APP_STORE_LINKS } from '../../_config/consts';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import GetAppIcon from '@material-ui/icons/GetApp';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import BusinessIcon from '@material-ui/icons/Business';
import BuildIcon from '@material-ui/icons/Build';
import { isMobileBrowser } from '../../_config/utils';

const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 20px',
    backgroundColor: '#157495',
    backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to right, rgba(21, 116, 149, 0.7), rgba(21, 116, 149, 0.7))',
      zIndex: 0,
    },
  },
  centerPanel: {
    width: '100%',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
  },
  logo: {
    height: '80px',
    marginBottom: '20px',
  },
  contentCard: {
    width: '100%',
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
  },
  stepItem: {
    padding: '28px 0',
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: 0,
    },
    '&:first-child': {
      paddingTop: 0,
    }
  },
  stepNumber: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    minWidth: '32px',
    minHeight: '32px',
    borderRadius: '6px',
    backgroundColor: '#157495',
    color: 'white',
    marginRight: '12px',
    flexShrink: 0,
  },
  stepTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '0px',
    display: 'flex',
    alignItems: 'center',
  },
  storeButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    marginTop: '12px',
  },
  appButton: {
    minWidth: '140px',
    height: '48px',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    }
  },
  finalStep: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 24px',
    backgroundColor: '#f0fdf4',
    borderRadius: '8px',
    border: '1px solid #4DB6AC',
    marginTop: '8px',
  },
});

@connect((state) => ({ setPassword: state.user.setPassword }))
class ResetPasswordOnboardingInstaller extends React.Component {
  
  openAppLink(operativeSystem) {
    const { setPassword } = this.props;
    const appLink = JAGO_TOOLS_APP_STORE_LINKS[operativeSystem];
    window.open(appLink);
  }

  render() {
    const { dispatch, classes } = this.props;
    const plantName = window && window.location && window.location.host && window.location.host.replace('.jago.cloud', '');
    const isMobile = isMobileBrowser();

    if (isMobile) {
      return (
        <div style={{
          minHeight: '100vh',
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          backgroundColor: '#157495',
        }}>
          <div style={{
            height: '120vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            padding: '20px 20px',
            position: 'relative',
          }}>
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              minHeight: '100%',
              background: 'linear-gradient(135deg, rgba(21, 116, 149, 0.92), rgba(18, 99, 127, 0.95))',
              zIndex: 0,
              pointerEvents: 'none',
            }} />
            <div style={{
              position: 'relative',
              zIndex: 2,
              width: '100%',
              maxWidth: '400px',
              paddingTop: '0px',
              paddingBottom: '40px',
            }}>
              <img 
                src="/imgs/common/logoJagoWhite.png" 
                alt="Luckey" 
                style={{
                  height: '50px',
                  marginBottom: '10px',
                  display: 'block',
                  margin: '0 auto 10px',
                }}
              />
              <Card style={{ 
                padding: '20px', 
                marginTop: '20px',
                borderRadius: '8px',
                backgroundColor: 'white',
                border: '1px solid #e8e8e8',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              }}>
                <h2 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#333',
                  textAlign: 'center',
                  marginTop: 0,
                  marginBottom: '24px',
                }}>
                  <Entity entity="followStepToLogin" />
                </h2>

                {/* Step 1 */}
                <div style={{ padding: '20px 0', borderBottom: '1px solid #f0f0f0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '14px' }}>
                    <div style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                      minWidth: '32px',
                      minHeight: '32px',
                      borderRadius: '6px',
                      backgroundColor: '#157495',
                      color: 'white',
                      marginRight: '12px',
                      flexShrink: 0,
                    }}>
                      <GetAppIcon style={{ fontSize: '18px' }} />
                    </div>
                    <h3 style={{ fontSize: '15px', fontWeight: '600', color: '#333', margin: 0 }}>
                      <Entity entity="stepOne" /> Installer App
                    </h3>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: '#4DB6AC',
                        color: 'white',
                        minWidth: '100px',
                        fontSize: '13px',
                        textTransform: 'none',
                        fontWeight: '600',
                        borderRadius: '6px',
                      }}
                      onClick={() => this.openAppLink('android')}
                      startIcon={<AndroidIcon />}
                    >
                      Android
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: '#555',
                        color: 'white',
                        minWidth: '100px',
                        fontSize: '13px',
                        textTransform: 'none',
                        fontWeight: '600',
                        borderRadius: '6px',
                        marginLeft: 8
                      }}
                      onClick={() => this.openAppLink('ios')}
                      startIcon={<AppleIcon />}
                    >
                      iOS
                    </Button>
                  </div>
                </div>

                {/* Step 2 */}
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '14px' }}>
                    <div style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                      minWidth: '32px',
                      minHeight: '32px',
                      borderRadius: '6px',
                      backgroundColor: '#157495',
                      color: 'white',
                      marginRight: '12px',
                      flexShrink: 0,
                    }}>
                      <BusinessIcon style={{ fontSize: '18px' }} />
                    </div>
                    <h3 style={{ fontSize: '15px', fontWeight: '600', color: '#333', margin: 0 }}>
                      <Entity entity="stepThree" />
                    </h3>
                  </div>
                  <p style={{
                    fontSize: '13px',
                    color: '#666',
                    lineHeight: '1.5',
                    margin: '0 0 14px 0',
                  }}>
                    <Entity entity="stepThreeDescriptionGuest" />
                  </p>
                  <div style={{
                    padding: '12px 14px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '6px',
                    border: '1px solid #e0e0e0',
                    textAlign: 'center',
                  }}>
                    <h2 style={{ 
                      fontSize: '15px', 
                      fontWeight: '600', 
                      color: '#157495',
                      margin: 0,
                      fontFamily: 'monospace',
                      letterSpacing: '0.5px',
                    }}>
                      {plantName || ''}
                    </h2>
                  </div>
                </div>
              </Card>

              {/* Final Step */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '16px 20px',
                backgroundColor: '#f0fdf4',
                borderRadius: '8px',
                border: '1px solid #4DB6AC',
                marginTop: '16px',
              }}>
                <BuildIcon style={{ color: '#4DB6AC', fontSize: 22, marginRight: 10 }} />
                <h3 style={{ 
                  color: '#4DB6AC', 
                  fontWeight: '600', 
                  margin: 0,
                  fontSize: '14px',
                }}>
                  <Entity entity="youReadyToInstall" />
                </h3>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <div className={classes.centerPanel}>
          <img 
            src="/imgs/common/logoJagoWhite.png" 
            alt="Luckey"
            className={classes.logo}
          />
          
          <div className={classes.contentCard}>
            <h2 style={{ 
              fontSize: '28px', 
              fontWeight: '600', 
              color: '#333',
              marginTop: 0,
              marginBottom: '32px',
              textAlign: 'center',
            }}>
              <Entity entity="followStepToLogin" />
            </h2>

            {/* Step 1 */}
            <div className={classes.stepItem}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <span className={classes.stepNumber}>
                  <GetAppIcon style={{ fontSize: '18px' }} />
                </span>
                <div className={classes.stepTitle}>
                  <Entity entity="stepOne" /> Installer Application
                </div>
              </div>
              <div className={classes.storeButtons}>
                <Button
                  variant="contained"
                  className={classes.appButton}
                  style={{
                    backgroundColor: '#4DB6AC',
                    color: 'white',
                  }}
                  onClick={() => this.openAppLink('android')}
                  startIcon={<AndroidIcon style={{ fontSize: 24 }} />}
                >
                  Android
                </Button>
                <Button
                  variant="contained"
                  className={classes.appButton}
                  style={{
                    backgroundColor: '#555',
                    color: 'white',
                  }}
                  onClick={() => this.openAppLink('ios')}
                  startIcon={<AppleIcon style={{ fontSize: 24 }} />}
                >
                  iOS
                </Button>
              </div>
            </div>

            {/* Step 2 */}
            <div className={classes.stepItem}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <span className={classes.stepNumber}>
                  <BusinessIcon style={{ fontSize: '18px' }} />
                </span>
                <div className={classes.stepTitle}>
                  <Entity entity="stepThree" />
                </div>
              </div>
              <p style={{
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.6',
                margin: '0 0 16px 0',
              }}>
                <Entity entity="stepThreeDescriptionGuest" />
              </p>
              <div style={{
                padding: '14px 18px',
                backgroundColor: '#f8f9fa',
                borderRadius: '6px',
                border: '1px solid #e0e0e0',
                textAlign: 'center',
              }}>
                <h2 style={{ 
                  fontSize: '18px', 
                  fontWeight: '600', 
                  color: '#157495',
                  fontFamily: 'monospace',
                  margin: 0,
                  letterSpacing: '0.5px',
                }}>
                  {plantName || ''}
                </h2>
              </div>
            </div>

            {/* Final Step */}
            <div className={classes.finalStep}>
              <BuildIcon style={{ color: '#4DB6AC', fontSize: 24, marginRight: 12 }} />
              <h3 style={{ 
                color: '#4DB6AC', 
                fontWeight: '600', 
                margin: 0,
                fontSize: '16px',
              }}>
                <Entity entity="youReadyToInstall" />
              </h3>
            </div>
          </div>
        </div>
      </div>
    );
  }
} 

export default withStyles(styles)(ResetPasswordOnboardingInstaller);
